export const firebaseConfig = {
    apiKey: "AIzaSyCVqrF1170Te4xCMu4L6GQrgnpou11QmKE",
    projectId: "done-4ff35",
    authDomain: "done-4ff35.firebaseapp.com",
    databaseURL: "https://done-4ff35.firebaseio.com",
    storageBucket: "done-4ff35.appspot.com",
    messagingSenderId: "972311616597",
};



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/config.ts